/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GoogleAccountView } from '../models/GoogleAccountView';
import type { GoogleConnectionStatusView } from '../models/GoogleConnectionStatusView';
import type { GoogleLocationView } from '../models/GoogleLocationView';
import type { GoogleReviewAiSettingsRequest } from '../models/GoogleReviewAiSettingsRequest';
import type { GoogleReviewAiSettingsView } from '../models/GoogleReviewAiSettingsView';
import type { GoogleReviewBulkGenerateRequest } from '../models/GoogleReviewBulkGenerateRequest';
import type { GoogleReviewBulkGenerateView } from '../models/GoogleReviewBulkGenerateView';
import type { GoogleReviewBulkPublishRequest } from '../models/GoogleReviewBulkPublishRequest';
import type { GoogleReviewBulkPublishResultView } from '../models/GoogleReviewBulkPublishResultView';
import type { GoogleReviewDraftRequest } from '../models/GoogleReviewDraftRequest';
import type { GoogleReviewGenerateReplyRequest } from '../models/GoogleReviewGenerateReplyRequest';
import type { GoogleReviewGenerateReplyView } from '../models/GoogleReviewGenerateReplyView';
import type { GoogleReviewListView } from '../models/GoogleReviewListView';
import type { GoogleReviewOAuthConnectView } from '../models/GoogleReviewOAuthConnectView';
import type { GoogleReviewPublishRequest } from '../models/GoogleReviewPublishRequest';
import type { GoogleReviewSyncStateView } from '../models/GoogleReviewSyncStateView';
import type { GoogleReviewView } from '../models/GoogleReviewView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GoogleReviewService {
    /**
     * Get Google connection status
     * @returns GoogleConnectionStatusView Connection status
     * @throws ApiError
     */
    public static getAppGoogleReviewConnectionStatus(): CancelablePromise<GoogleConnectionStatusView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/google-review/connection-status',
        });
    }
    /**
     * List GBP accounts
     * @returns GoogleAccountView GBP accounts
     * @throws ApiError
     */
    public static getAppGoogleReviewAccounts(): CancelablePromise<Array<GoogleAccountView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/google-review/accounts',
            errors: {
                403: `Google not connected or token expired`,
            },
        });
    }
    /**
     * List GBP locations for an account
     * @param accountId Full Google account resource name
     * @returns GoogleLocationView GBP locations
     * @throws ApiError
     */
    public static getAppGoogleReviewLocations(
        accountId: string,
    ): CancelablePromise<Array<GoogleLocationView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/google-review/locations',
            query: {
                'accountId': accountId,
            },
            errors: {
                403: `Google not connected or token expired`,
            },
        });
    }
    /**
     * List reviews for a location
     * @param locationId
     * @param filter
     * @param rating
     * @param includeRatingOnly Include reviews without a comment (default true)
     * @param page
     * @param pageSize
     * @returns GoogleReviewListView Review list
     * @throws ApiError
     */
    public static getAppGoogleReviewReviews(
        locationId: string,
        filter?: 'all' | 'needs_reply' | 'draft' | 'published',
        rating?: number,
        includeRatingOnly: boolean = true,
        page: number = 1,
        pageSize: number = 20,
    ): CancelablePromise<GoogleReviewListView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/google-review/reviews',
            query: {
                'locationId': locationId,
                'filter': filter,
                'rating': rating,
                'includeRatingOnly': includeRatingOnly,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                403: `Google not connected or token expired`,
            },
        });
    }
    /**
     * Generate AI reply for a review
     * @param requestBody
     * @returns GoogleReviewGenerateReplyView Generated reply text
     * @throws ApiError
     */
    public static postAppGoogleReviewGenerateReply(
        requestBody: GoogleReviewGenerateReplyRequest,
    ): CancelablePromise<GoogleReviewGenerateReplyView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/google-review/reviews/generate-reply',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Google not connected or subuser not allowed`,
            },
        });
    }
    /**
     * Save review reply draft
     * @param requestBody
     * @returns GoogleReviewView Updated review view
     * @throws ApiError
     */
    public static postAppGoogleReviewSaveDraft(
        requestBody: GoogleReviewDraftRequest,
    ): CancelablePromise<GoogleReviewView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/google-review/reviews/draft',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Publish review reply to Google
     * @param requestBody
     * @returns any Published
     * @throws ApiError
     */
    public static postAppGoogleReviewPublish(
        requestBody: GoogleReviewPublishRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/google-review/reviews/publish',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Bulk generate AI replies (max 20)
     * @param requestBody
     * @returns GoogleReviewBulkGenerateView Generated drafts
     * @throws ApiError
     */
    public static postAppGoogleReviewBulkGenerate(
        requestBody: GoogleReviewBulkGenerateRequest,
    ): CancelablePromise<GoogleReviewBulkGenerateView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/google-review/reviews/bulk/generate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Bulk publish review replies (max 20)
     * @param requestBody
     * @returns GoogleReviewBulkPublishResultView Bulk publish result
     * @throws ApiError
     */
    public static postAppGoogleReviewBulkPublish(
        requestBody: GoogleReviewBulkPublishRequest,
    ): CancelablePromise<GoogleReviewBulkPublishResultView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/google-review/reviews/bulk/publish',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Start a review sync for the current account
     * @returns GoogleReviewSyncStateView Sync started, already running, or reconnect required — see sync state
     * @throws ApiError
     */
    public static postAppGoogleReviewSync(): CancelablePromise<GoogleReviewSyncStateView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/google-review/sync',
            errors: {
                429: `Daily sync limit reached (cooldown or backoff)`,
            },
        });
    }
    /**
     * Get Google OAuth authorization URL
     * @returns GoogleReviewOAuthConnectView OAuth URL
     * @throws ApiError
     */
    public static getAppGoogleReviewOauthConnect(): CancelablePromise<GoogleReviewOAuthConnectView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/google-review/oauth/connect',
            errors: {
                403: `Subuser not allowed or Google error`,
            },
        });
    }
    /**
     * Disconnect Google account
     * @returns any Disconnected
     * @throws ApiError
     */
    public static deleteAppGoogleReviewOauthDisconnect(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/google-review/oauth/disconnect',
            errors: {
                403: `Subuser not allowed`,
            },
        });
    }
    /**
     * Get AI reply settings
     * @returns GoogleReviewAiSettingsView Current settings or defaults
     * @throws ApiError
     */
    public static getAppGoogleReviewSettingsGet(): CancelablePromise<GoogleReviewAiSettingsView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/google-review/settings',
            errors: {
                403: `Google not connected`,
            },
        });
    }
    /**
     * Save AI reply settings
     * @param requestBody
     * @returns GoogleReviewAiSettingsView Saved settings
     * @throws ApiError
     */
    public static putAppGoogleReviewSettingsPut(
        requestBody: GoogleReviewAiSettingsRequest,
    ): CancelablePromise<GoogleReviewAiSettingsView> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/google-review/settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Subuser not allowed`,
            },
        });
    }
}
